import React from 'react';

const CardCategoryShimmer = () => {
    // Créer un tableau de 6 éléments pour le shimmer initial
    const shimmerArray = Array(6).fill(null);

    return (
        <div className="mt-10">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
                {shimmerArray.map((_, index) => (
                    <div
                        key={index}
                        className="relative overflow-hidden rounded-md"
                    >
                        <div className="aspect-[3/2] w-full animate-pulse bg-gray-200 rounded-md">
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-3/4 h-6 bg-gray-300 rounded animate-pulse"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CardCategoryShimmer;